import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { dbFs } from "./database";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    cart: [],
    user: null,
    products: [],
    vendorProducts: [],
    VendorId: null,
    Wallet: {
      txnRewardsBalance: 0,
      txnAamcartBalance: 0
    },
    carts: [],
    userRole: null,
    orders: {
      loading: false,
      data: null,
      error: null,
      allData: null
    }
  },
  getters: {
    getCart: state => state.cart,
    getUser: state => state.user,
    getProducts: state => state.products,
    getVendorProducts: state => state.vendorProducts,
    getVendorId: state => state.VendorId,
    getDataCart: state => state.carts,
    getRole: state => state.userRole,
    getOrders: state => state.orders,
    getWallet: state => state.Wallet
  },
  mutations: {
    updateCart(state, cartObject) {
      state.cart = cartObject.cart;
    },
    addToCart(state, productObject) {
      let found = state.cart.find(
        product => product.productId == productObject.product.productId
      );
      if (!found) {
        state.cart.push(productObject.product);
      } else {
        found.p_qty++;
      }
    },
    removeCart(state, item) {
      let index = --item.cart;
      state.cart.splice(index, 1);
    },
    emptyCart(state) {
      state.cart = [];
    },
    updateUser(state, userObject) {
      state.user = userObject.user;
    },
    updateProducts(state, userObject) {
      state.products = userObject.products;
    },
    updateVendorProducts(state, userObject) {
      state.vendorProducts = userObject.vendorProducts;
    },
    updateVendorId(state, userObject) {
      state.VendorId = userObject.VendorId;
    },
    updateUserRole(state, userObject) {
      state.userRole = userObject.UserRole;
    },
    updateWallet(state, userObject) {
      state.Wallet = userObject.Wallet;
    },
    clearAuth(state) {
      state.user = null;
    },
    clearProducts(state) {
      state.products = [];
    },
    clearVendorProducts(state) {
      state.vendorProducts = [];
    },
    clearVendorId(state) {
      state.VendorId = null;
    },
    clearUserRole(state) {
      state.UserRole = null;
    },
    clearWallet(state) {
      state.Wallet = [];
    },
    addToCartAll(state, payload) {
      state.carts = payload;
    },
    setOrderData(state, data) {
      state.orders = {
        ...state.orders,
        loading: false,
        error: false,
        data,
        allData: null
      };
    },
    clearOrders(state) {
      state.orders = {
        ...state.orders,
        loading: true,
        error: false,
        data: null,
        allData: null,
        ready: null
      };
    },
    setPackerOrders(state, data) {
      state.orders = {
        ...state.orders,
        loading: false,
        error: false,
        data: data.assignProducts,
        allData: data.allProducts,
        ready: data.readyProdcuts
      };
    },
    setCurrentVendor(state, data) {
      state.orders.data = {
        pending: data.pending,
        packing: data.packing,
        packed: data.packed,
        forDelivery: data.forDelivery,
        delivered: data.delivered
      };
    }
  },
  actions: {
    addCart({ commit }, payload) {
      commit("addToCartAll", payload.carts);
    },
    emptyCart(context) {
      context.commit("emptyCart");
    },
    RemoveCart({ commit }, cart) {
      commit("removeCart", cart);
    },
    updateCart({ commit }, cart) {
      commit("updateCart", cart);
    },
    updateUser({ commit }, user) {
      commit("updateUser", user);
    },
    updateProducts({ commit }, products) {
      commit("updateProducts", products);
    },
    updateVendorProducts({ commit }, products) {
      commit("updateVendorProducts", products);
    },
    updateVendorId({ commit }, products) {
      commit("updateVendorId", products);
    },
    updateUserRole({ commit }, products) {
      commit("updateUserRole", products);
    },
    updateWallet({ commit }, products) {
      commit("updateWallet", products);
    },
    clearAuth(context) {
      context.commit("clearAuth");
    },
    clearProducts(context) {
      context.commit("clearProducts");
    },
    clearVendorProducts(context) {
      context.commit("clearVendorProducts");
    },
    clearVendorId(context) {
      context.commit("clearVendorId");
    },
    clearUserRole(context) {
      context.commit("clearUserRole");
    },
    clearWallet(context) {
      context.commit("clearWallet");
    },
    setOrder(context) {
      context.commit("clearOrders");
      const orders = [];
      const vendors = [];
      const products = [];
      const allProducts = [];
      const users = [];
      const simpleData = [];

      dbFs
        .collection("customer")
        .get()
        .then(ct => {
          ct.forEach(doc => {
            users.push({ ...doc.data(), userId: doc.id });
          });
        })
        .catch(err => {
          console.log(err);
        });

      dbFs
        .collection("products")
        .get()
        .then(prod => {
          prod.forEach(doc => {
            allProducts.push(doc.data());
          });
        })
        .catch(err => {
          console.log(err);
        });
      dbFs
        .collection("order")
        .orderBy("createdAt", "desc")
        .get()
        .then(res => {
          res.forEach(doc => {
            orders.push({ ...doc.data(), orderId: doc.id });
          });
          getOrderInformation();
        })
        .catch(err => {
          console.log("from actions", err);
        });

      const getOrderInformation = () => {
        orders.forEach((od, index) => {
          dbFs
            .collection("order")
            .doc(od.orderId)
            .collection("vendor")
            .get()
            .then(document => {
              let tempData = [];

              document.forEach(vd => {
                vendors.push({ ...vd.data(), orderId: od.orderId });
                tempData.push({ ...vd.data(), orderId: od.orderId });
              });

              tempData.forEach(pd => {
                pd.product.forEach(pds => {
                  products.push({
                    ...pds,
                    orderId: pd.orderId,
                    currentStatus: pd.status[0]
                  });
                });
              });

              tempData = [];
              if (index === orders.length - 1) {
                getProductsDetails();
              }
            });
        });
      };

      const getProductsDetails = () => {
        let productsWithName = [];

        orders.forEach(od => {
          const userData = users.find(user => user.userId === od.customerId);

          const ordersData = vendors.filter(
            vend => vend.orderId === od.orderId
          );

          const productsData = products.filter(
            pod => pod.orderId === od.orderId
          );

          productsData.forEach(pd => {
            const productsName = allProducts.find(ap => {
              return ap.productId === pd.productId;
            });

            productsWithName.push({
              ...productsName,
              currentStatus: pd.currentStatus,
              ...pd
            });
          });

          simpleData.push({
            ...userData,
            order: ordersData,
            product: productsWithName,
            ...od
          });
          productsWithName = [];
        });

        context.commit("setOrderData", simpleData);
      };
    },
    getVendorOrders(context) {
      context.commit("clearOrders");
      //loggedin userId
      const vendorId = context.state.VendorId;

      const orders = [];
      const customers = [];
      let products = [];
      const allProducts = [];
      let readyProdcuts = [];

      dbFs
        .collection("order")
        .where("vendorId", "array-contains", vendorId)
        // .orderBy("createdAt", "desc")
        .get()
        .then(res => {
          res.forEach(doc => {
            orders.push({ ...doc.data(), orderId: doc.id });
          });
          getCustomers();
        })
        .catch(err => {
          console.log(err);
        });

      const getCustomers = () => {
        orders.forEach((ord, index) => {
          dbFs
            .collection("customer")
            .doc(ord.customerId)
            .get()
            .then(doc => {
              customers.push({
                ...doc.data(),
                uid: doc.id,
                order: ord,
                venderId: vendorId
              });

              if (index === orders.length - 1) {
                getProducts();
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      };

      const getProducts = () => {
        customers.forEach((ct, indexs) => {
          const ctlength = customers.length - 1;
          ct.order.vendorId.forEach(vd => {
            if (vd === vendorId) {
              dbFs
                .collection("order")
                .doc(ct.order.orderId)
                .collection("vendor")
                .doc(vendorId)
                .get()
                .then(doc => {
                  // if (doc.data().status[0].type === "0") {
                  //   products.push({...ct, products: doc.data()});
                  // }

                  allProducts.push({ ...ct, products: doc.data() });
                  // console.log(ctlength, indexs, "checkerror");

                  if (indexs === ctlength) {
                    getProductsName();
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          });
        });
      };

      const getProductsName = () => {
        console.log("dispatching");
        allProducts.forEach((pd, index) => {
          pd.products.product.forEach((prod, i) => {
            dbFs
              .collection("products")
              .doc(prod.productId)
              .get()
              .then(doc => {
                allProducts[index].products.product[i].name = doc.data().name;

                if (index === allProducts.length - 1) {
                  filterProducts();
                }
              })
              .catch(err => {
                console.log(err);
              });
          });
        });
      };

      const filterProducts = () => {
        products = allProducts.filter(
          prod =>
            prod.products.status[0].type === "1" &&
            prod.products.packer === true &&
            prod.products.packStatus === false
        );

        readyProdcuts = allProducts.filter(
          prod => prod.products.status[0].type === "0"
        );

        context.commit("setPackerOrders", {
          assignProducts: products,
          readyProdcuts: readyProdcuts,
          allProducts: allProducts
        });
      };
    },
    getCurrentVendorOrders(context) {
      context.commit("clearOrders");
      //loggedin userId
      const vendorId = context.state.VendorId;

      const orders = [];
      const customers = [];
      const allProducts = [];
      const vendorProducts = [];
      let pendingOrders = [];
      let currentyPacking = [];
      let packed = [];
      let forDelivery = [];
      let delivered = [];

      dbFs
        .collection("products")
        .get()
        .then(prod => {
          prod.forEach(doc => {
            allProducts.push(doc.data());
          });
        })
        .catch(err => {
          console.log(err);
        });

      dbFs
        .collection("order")
        .where("vendorId", "array-contains", vendorId)
        // .orderBy("createdAt", "desc")
        .get()
        .then(res => {
          res.forEach(doc => {
            orders.push({ ...doc.data(), orderId: doc.id });
          });
          getCustomers();
        })
        .catch(err => {
          console.log(err);
        });

      const getCustomers = () => {
        orders.forEach((ord, index) => {
          dbFs
            .collection("customer")
            .doc(ord.customerId)
            .get()
            .then(doc => {
              customers.push({
                ...doc.data(),
                uid: doc.id,
                order: ord,
                venderId: vendorId
              });

              if (index === orders.length - 1) {
                getProducts();
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      };

      const getProducts = () => {
        customers.forEach((ct, indexs) => {
          const ctlength = customers.length - 1;
          ct.order.vendorId.forEach(vd => {
            if (vd === vendorId) {
              dbFs
                .collection("order")
                .doc(ct.order.orderId)
                .collection("vendor")
                .doc(vendorId)
                .get()
                .then(doc => {
                  // if (doc.data().status[0].type === "0") {
                  //   products.push({...ct, products: doc.data()});
                  // }

                  vendorProducts.push({ ...ct, products: doc.data() });
                  console.log(customers.length - 1, indexs, "checkerror");

                  if (indexs === ctlength) {
                    getProductsName();
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          });
        });
      };

      const getProductsName = () => {
        // console.log("dispatching");
        vendorProducts.forEach((pd, index) => {
          pd.products.product.forEach((prod, i) => {
            const tempProd = allProducts.find(
              ap => ap.productId === prod.productId
            );
            // dbFs
            //   .collection("products")
            //   .doc(prod.productId)
            //   .get()
            //   .then(doc => {

            if (tempProd) {
              vendorProducts[index].products.product[i].name = tempProd.name;
            }

            if (index === vendorProducts.length - 1) {
              filterProducts();
            }
            // })
            // .catch(err => {
            //   console.log(err);
            // });
          });
        });
      };

      const filterProducts = () => {
        currentyPacking = vendorProducts.filter(
          prod =>
            prod.products.status[0].type === "1" &&
            prod.products.packer === true &&
            prod.products.packStatus === false
        );

        packed = vendorProducts.filter(
          prod =>
            prod.products.status[0].type === "1" &&
            prod.products.packer === true &&
            prod.products.packStatus === true
        );

        forDelivery = vendorProducts.filter(
          prod => prod.products.status[0].type === "2"
        );

        pendingOrders = vendorProducts.filter(
          prod => prod.products.status[0].type === "0"
        );

        delivered = vendorProducts.filter(
          prod => prod.products.status[0].type === "3"
        );

        context.commit("setCurrentVendor", {
          pending: pendingOrders,
          packing: currentyPacking,
          packed: packed,
          forDelivery: forDelivery,
          delivered: delivered
        });

        console.log(context.state.orders);
      };
    }
  },
  plugins: [createPersistedState()]
});
